<script setup>
  import { log } from '@/services/log'
  import { onMounted, computed, inject } from 'vue'
  import { useRoute } from 'vue-router'
  import {
    NConfigProvider,
    NLoadingBarProvider,
    NMessageProvider,
    NNotificationProvider,
    NDialogProvider,
    NGlobalStyle,
    useOsTheme,
    darkTheme,
    lightTheme,
  } from 'naive-ui'
  import { useInjects } from '@/services/log'
  import { useAuthStore } from '@/stores/auth'
  import SiteLayout from '@/SiteLayout.vue'
  import LockScreen from '@/components/utilities/lock-screen.vue'

  const appStoreFn = inject('appStoreFn')
  const appStore = appStoreFn()
  const authStore = useAuthStore()
  const dexie = inject('dexie')
  // const givenThemeOverrides = inject('themeOverrides')
  // Needed so the log module is fallback ready for production builds when we do not log to console
  useInjects(dexie, authStore)
  const isLock = computed(() => appStore.screenLockState.locked)
  const lockTime = computed(() => appStore.screenLockState.lockTime)
  const route = useRoute()
  const storeRef = computed(() => (route?.meta?.storeFn ? route?.meta?.storeFn() : {}))
  const tourSteps = computed(() => storeRef.value?.tourSteps ?? [])
  const tourOptions = computed(() => appStore?.tourOptions ?? {})
  const light = inject('lightThemeOverrides')
  const dark = inject('darkThemeOverrides')
  const themeOverrides = computed(() => (appStore.appTheme === 'dark' ? dark : light))
  const theme = computed(() => (appStore.appTheme === 'dark' ? darkTheme : lightTheme))

  let timer
  const timekeeping = () => {
    clearInterval(timer)
    if (route.name == 'login' || isLock.value) return

    appStore.updateScreenLock(false)

    appStore.setScreenLockTime()
    timer = setInterval(() => {
      appStore.setScreenLockTime(lockTime.value - 1)
      if (lockTime.value <= 0) {
        appStore.updateScreenLock(true)
        return clearInterval(timer)
      }
    }, 1000)
  }

  onMounted(() => {
    if (!appStore.appTheme) {
      const osTheme = useOsTheme().value
      appStore.updateTheme(osTheme)
    }
    log('App theme', appStore.appTheme)
    timekeeping()
    document.addEventListener('mousemove', timekeeping)
  })
</script>

<template>
  <NConfigProvider
    v-if="!isLock"
    :theme="theme"
    :theme-overrides="themeOverrides"
  >
    <NLoadingBarProvider>
      <NMessageProvider>
        <NNotificationProvider>
          <NDialogProvider>
            <SiteLayout />
          </NDialogProvider>
        </NNotificationProvider>
      </NMessageProvider>
    </NLoadingBarProvider>
    <NGlobalStyle />
  </NConfigProvider>
  <Transition
    v-if="isLock && $route.name !== 'login'"
    name="slide-up"
  >
    <LockScreen />
  </Transition>
  <v-tour
    name="arsTour"
    :steps="tourSteps"
    :options="tourOptions"
  ></v-tour>
</template>
